var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosNodeContext } from "./../../ricos-context";
import collapsibleListItemStyles from "../statics/styles/collapsible-list-pair.rtlignore-scss";
import { getAlignmentFromDirection } from "../utils";
const CollapsibleListItemProperty = ({
  node,
  RicosNodesRenderer,
  type
}) => {
  var _a, _b;
  const { parentNode } = useContext(RicosNodeContext);
  const parentNodeDirection = (_a = parentNode == null ? void 0 : parentNode.collapsibleListData) == null ? void 0 : _a.direction;
  const listAlignment = parentNodeDirection ? getAlignmentFromDirection(parentNodeDirection) : void 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(
        collapsibleListItemStyles.container,
        collapsibleListItemStyles.viewerContainer,
        type === "title" ? collapsibleListItemStyles.titleContainer : null,
        collapsibleListItemStyles.innerEditor
      )
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: "100%",
          textAlign: listAlignment
        }
      },
      /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_b = node.nodes) != null ? _b : [], shouldParagraphApplyTextStyle: true })
    )
  );
};
const CollapsibleListItemTitleProperty = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, __spreadProps(__spreadValues({ key: node.id, node }, props), { type: "title" }));
};
const CollapsibleListItemBodyProperty = (_c) => {
  var _d = _c, { node } = _d, props = __objRest(_d, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, __spreadProps(__spreadValues({ key: node.id, node }, props), { type: "body" }));
};
var collapsibleItemProperty_default = CollapsibleListItemProperty;
export {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty,
  collapsibleItemProperty_default as default
};
//# sourceMappingURL=collapsibleItemProperty.js.map

import "@wix/ricos/css/plugin-collapsible-list-viewer.global.css";